import { Component } from "@angular/core";

import { SvgMixinComponent } from "../svg-mixin.component";

@Component({
  selector: "med-icon-bluetooth",
  templateUrl: "./med-icon-bluetooth.component.html",
})
export class MedIconBluetoothComponent extends SvgMixinComponent {}
